require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-react-script-loader.json") })
        }
      }, "path---package-bs-react-script-loader");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-react-script-loader!./.cache/json/package-bs-react-script-loader.json
// module id = 827
// module chunks = 231608221292675